import useTheme from '@common/hooks/useTheme'
import { THEME_TYPES } from '@common/styles/themeConfig'
import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const LifiIcon: React.FC<SvgProps> = ({ width = 90, height = 32 }) => {
  const { themeType } = useTheme()
  const fill = themeType === THEME_TYPES.DARK ? 'white' : 'black'
  return (
    <Svg fill="none" height={height} viewBox="0 0 90 32" width={width}>
      <Path
        d="M16.3302 0L22.916 6.58579C23.6971 7.36684 23.6971 8.63317 22.916 9.41421L18.9969 13.3333L16.3302 10.6667C13.3847 7.72115 13.3847 2.94552 16.3302 0Z"
        fill={fill}
      />
      <Path
        clipRule="evenodd"
        d="M16.3328 31.9993L5.66617 21.3327C2.72065 18.3872 2.72065 13.6115 5.66617 10.666L14.9186 19.9185C15.6997 20.6995 16.966 20.6995 17.7471 19.9185L26.9995 10.666C29.945 13.6115 29.945 18.3872 26.9995 21.3327L16.3328 31.9993Z"
        fill={fill}
        fillRule="evenodd"
      />
      <Path
        d="M85.6685 24C85.6685 24 85.6913 10.0003 85.6685 9.33366C85.6458 8.66699 86.3249 8.00007 86.9791 8.00005C87.6333 8.00002 88.5292 8 89.6685 8V22.6667C89.6919 23.3333 89.0252 24 88.3585 24C87.6919 24 87.1805 24 85.6685 24Z"
        fill={fill}
      />
      <Path
        d="M69.6719 9.33333V24H73.6719V18.6667H80.3385C81.0052 18.6667 81.6719 18 81.6719 17.3333V14.6667H73.6719V12H81.6719C82.3385 12 83.0052 11.3333 83.0052 10.6667V8H71.0052C70.3385 8 69.6719 8.66667 69.6719 9.33333Z"
        fill={fill}
      />
      <Path
        d="M63.0039 21.3333C63.0039 20.6667 63.6706 20 64.3372 20C65.0039 20 65.0039 20 65.6706 20C66.3372 20 67.0039 20.6667 67.0039 21.3333C67.0039 22 67.0039 22 67.0039 22.6667C67.0039 23.3333 66.3372 24 65.6706 24C65.0039 24 65.0039 24 64.3372 24C63.6706 24 63.0039 23.3333 63.0039 22.6667C63.0039 22 63.0039 22 63.0039 21.3333Z"
        fill={fill}
      />
      <Path
        d="M56.3365 24C56.3365 24 56.3593 10.0003 56.3365 9.33366C56.3137 8.66699 56.9928 8.00007 57.6471 8.00005C58.3013 8.00002 59.1972 8 60.3365 8V22.6667C60.3599 23.3333 59.6932 24 59.0265 24C58.3599 24 57.8485 24 56.3365 24Z"
        fill={fill}
      />
      <Path
        d="M40.3359 20C40.3359 20 40.3359 10.0002 40.3359 9.33353C40.3359 8.66686 40.9155 8.00019 41.6693 8.00017C42.5325 8.00015 43.6242 8.0001 44.3359 8V20H53.6693C53.6693 20 53.6693 22.0002 53.6693 22.6669C53.6693 23.3335 53.0026 24 52.3359 24C51.6693 24 40.3359 24 40.3359 24V20Z"
        fill={fill}
      />
    </Svg>
  )
}

export default React.memo(LifiIcon)
